<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="月" prop="monthList">
                <el-select v-model="queryCondition.monthList" multiple  clearable style="width:100%" placeholder="请选择(支持多选)">
                  <el-option :key="index" v-for="(item,index) in monthList" :label="item" :value="item"></el-option>
                </el-select>
                <!-- <ic-select clearable table="TT_QSPI_QBR" field="MONTH" v-model="queryCondition.monthList" multiple placeholder="请选择(支持多选)" style="width:100%"></ic-select> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd">新增</el-button>
        <el-button :disabled="multipleSelection.length>0?false:true" size="mini" class="btn" type="danger" @click="onDel">删除</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData"  @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="月" field="month">
          <template v-slot="scope">
            <el-button type="text" @click="onAdd(scope.row)">{{scope.row.month}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="GC" field="gc"></ux-table-column>
        <ux-table-column align="center" title="更新人" field="updateUser"></ux-table-column>
        <ux-table-column align="center" title="更新时间" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="维护GC" :visible.sync="showGcDialog" append-to-body width="30%" :close-on-click-modal="false" @close="closeGcDialog">
      <el-form :rules="rules" :model="gcForm" ref="gcForm" label-width="100px" >
        <el-form-item label="月" >
          <el-select v-model="gcForm.month" :disabled="isRow?true:false" clearable style="width:100%" placeholder="请选择">
            <el-option :key="index" v-for="(item,index) in monthList" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="GC" prop="gc">
          <el-input v-model="gcForm.gc" maxlength="10" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onSave('gcForm')">保存</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import ReceiveValue from "@/api/ReceiveValue/index";
import commonFunction from "@/utils/dataTableUtils";
import DQMPApi from "@/api/DQMP/index";



export default {
  name: '',
  components: {
    IcSelect,
  },
  data() {
    return {
      rules:{
        gc:[
          { required: true, message: '请选择GC', trigger: 'blur' }
        ]
      },
      isRow:false,
      showGcDialog: false,
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        monthList:[]
      },
      gcForm: {},
      monthList: [],
      tableData: [],
      multipleSelection:[],
    }
  },
  created() {
    this.getMonth()
    this.queryData();
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      ReceiveValue.gcQuery(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.totalCount=res.totalCount
      })
    },
    onReset() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition.pageNum=1
      this.queryData();
    },  
    onSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ReceiveValue.gcUpdate(this.gcForm).then((res)=>{
            if(this.gcForm.ttQspiGcId){
            this.$message.success('修改成功')
            }else{
            this.$message.success('新增成功')
            }
            this.showGcDialog = false
            this.queryData();
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onDel() {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids=[]
        this.multipleSelection.forEach((v)=>{
          ids.push(v.ttQspiGcId)
        })
        ReceiveValue.gcDelete(ids).then((res)=>{
          this.$message.success("删除成功")
          this.queryData();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
      
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onAdd(val) {
      if(val&&val.ttQspiGcId){
        this.$set(this.gcForm,'ttQspiGcId',val.ttQspiGcId)
        this.$set(this.gcForm,'gc',val.gc)
        this.$set(this.gcForm,'month',val.month)
        this.isRow=true
      }else{
        this.gcForm={}
        this.isRow=false
      }
      this.showGcDialog = true
    },
    closeGcDialog() {
      this.showGcDialog = false
    },
    selectionChange(val){
      this.multipleSelection=val
    },
    getMonth() {
      DQMPApi.getMonth().then(res => {
        this.monthList = res
      })
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
